import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { DeepBI } from "../../../integrations";
import styles from "./styles.m.css";

export default function GooglePreference({ story }) {
  const handleClick = e => {
    e.stopPropagation();
    DeepBI.pingPaywallEventTrigger(story, "GooglePreferenceClicked");
  };

  useEffect(() => {
    DeepBI.pingPaywallEventTrigger(story, "GooglePreferenceButtonEnabled");
  }, []);

  return (
    <div className={styles["google-preference-container"]}>
      <div className="hidden-mobile">
        <a
          href="https://www.google.com/preferences/source?q=vikatan.com"
          target="_blank"
          rel="noopener noreferrer"
          className={styles["google-preference-btn"]}
          onClick={handleClick}
        >
          <img
            src="https://media.vikatan.com/vikatan/2026-03-18/hgrja67p/desktopgooglepreferred.gif?q=100&w=300"
            alt="Google Preference"
            className={styles["google-preference-img"]}
          />
        </a>
      </div>
      <div className="hidden-desktop">
        <a
          href="https://www.google.com/preferences/source?q=vikatan.com"
          target="_blank"
          rel="noopener noreferrer"
          className={styles["google-preference-btn"]}
          onClick={handleClick}
        >
          <img
            src="https://media.vikatan.com/vikatan/2026-03-18/9y50xird/mobilegooglepreferred.gif?q=100&w=100"
            alt="Google Preference"
            className={styles["google-preference-img"]}
          />
        </a>
      </div>
    </div>
  );
}

GooglePreference.propTypes = {
  story: PropTypes.shape()
};
